import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const ProjectCard = ({ project }) => {
  const { id, title, category, description, image_url, location } = project;

  return (
    <Link
      to={`/projects/${id}`}
      className="project-card relative aspect-[4/5] overflow-hidden group cursor-pointer block"
      data-testid={`project-card-${id}`}
    >
      {/* Image */}
      <img
        src={image_url}
        alt={title}
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
      />

      {/* Overlay */}
      <div className="project-overlay absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/50 to-transparent flex flex-col justify-end p-6">
        {/* Category Badge */}
        <span className="text-[#7ED4C6] text-xs uppercase tracking-widest mb-2">
          {category}
        </span>

        {/* Title */}
        <h3 className="font-['Oswald'] text-xl font-semibold text-white mb-2">
          {title}
        </h3>

        {/* Location */}
        {location && (
          <p className="text-[#A1A1AA] text-sm mb-3">{location}</p>
        )}

        {/* Description */}
        <p className="text-[#A1A1AA] text-sm line-clamp-2 mb-4">
          {description}
        </p>

        {/* View Project */}
        <div className="flex items-center gap-2 text-[#7ED4C6] text-sm font-semibold uppercase tracking-wider group-hover:gap-4 transition-all">
          View Project
          <ArrowRight size={16} />
        </div>
      </div>

      {/* Border Animation */}
      <div className="absolute inset-0 border border-transparent group-hover:border-[#7ED4C6]/50 transition-colors duration-500 pointer-events-none" />
    </Link>
  );
};
